import script from "./ChecklistDocsPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChecklistDocsPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ChecklistDocsPopup.vue?vue&type=style&index=0&id=7d9058c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d9058c6"]])

export default __exports__